/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'api-dealer-data-change';

let _store = {
    dealers        : [],
    dealerUsers    : [],
    dealerJobs     : [],
    activeDealer   : null,
    lastFailure    : null
};

class DealerStoreClass extends EventEmitter {
    constructor() {
        super();
        console.log("[Dealer Store] - initialisation");
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    dealers() {
        return _store.dealers ;
    }

    dealerUsers() {
        return _store.dealerUsers ;
    }

    dealerJobs() {
        return _store.dealerJobs ;
    }

    activeDealer() {
        return _store.activeDealer ;
    }

    lastFailure() {
        return _store.lastFailure ;
    }

    clearDealer() {
        _store.activeDealer = null ;
        _store.dealerJobs = [] ;
        _store.dealerUsers = [] ;
    }
}

const DealerStore = new DealerStoreClass();

AppDispatcher.register((payload) => {
  const action = payload.action;
 
  switch (action.actionType) {
    case AppConstants.ALL_DEALERS: 
        console.log("[DealerStore] ALL_DEALERS: ", action);
        _store.dealers = action.result || [];
        DealerStore.emit(CHANGE_EVENT,AppConstants.ALL_DEALERS);
        break ;

    case AppConstants.ALL_DEALER_USERS: 
        console.log("[DealerStore] ALL_DEALER_USERS: ", action);
        _store.dealerUsers = action.result || [];
        DealerStore.emit(CHANGE_EVENT,AppConstants.ALL_DEALER_USERS);
        break ;

    case AppConstants.ALL_DEALERS_ERR: 
        console.log("[DealerStore] ALL_DEALERS_ERR: ", action);
        _store.lastFailure = action.error ;
        DealerStore.emit(CHANGE_EVENT,AppConstants.ALL_DEALERS_ERR);
        break ;

    case AppConstants.DELETE_DEALER:
        DealerStore.emit(CHANGE_EVENT, AppConstants.DELETE_DEALER) ;
        break ;

    case AppConstants.DELETE_DEALER_ERR:
        DealerStore.emit(CHANGE_EVENT, AppConstants.DELETE_DEALER_ERR) ;
        break ;

    case "DEALER-JOBS-LOADED" :
        console.log("DEALER JOBS LOADED - ", action.result) ;
        var jobs = JSON.parse(action.result.body);
        console.log("DEALER JOBS=", jobs);
        _store.dealerJobs = JSON.parse(action.result.body);
        DealerStore.emit(CHANGE_EVENT, "DEALER-JOBS-LOADED") ;
        break ;

    case "DEALER-JOBS-LOADED-ERROR" :
        console.log("DEALER JOBS LOAD ERROR ", action) ;     
        DealerStore.emit(CHANGE_EVENT, "DEALER-JOBS-LOADED-ERROR") ;   
        break ;

    default:
        return true;
  }
});

export default DealerStore;




// WEBPACK FOOTER //
// ./src/app/stores/DealerStore.js